import { useState, useEffect } from 'react';
import { priceService, Categoria } from '../services/priceService';

export const useCategories = () => {
    const [categorias, setCategorias] = useState<Categoria[]>([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const carregarCategorias = async () => {
        setLoading(true);
        setError(null);

        try {
            const categoriasData = await priceService.listarCategorias();
            // Ordenar categorias em ordem alfabética pelo campo 'secao'
            const categoriasOrdenadas = [...categoriasData].sort((a, b) => 
                a.secao.localeCompare(b.secao, 'pt-BR', { sensitivity: 'base' })
            );
            setCategorias(categoriasOrdenadas);
        } catch (err) {
            const errorMessage = err instanceof Error ? err.message : 'Erro ao carregar categorias';
            setError(errorMessage);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        carregarCategorias();
    }, []);

    return {
        categorias,
        loading,
        error,
        recarregar: carregarCategorias,
    };
};

